import React from 'react';
import { connect } from 'react-redux';
import { AlTemplateSelfCareRow } from 'PatientCareCenter/Note/AL/Templates';
import styles from './Common.module.css';


class AlTemplateSelfCare extends React.Component {

    render() {
        if (this.props.activities.length > 0) {
            return (
                <div className={styles.section_wrapper}>
                    <div className={styles.header_row}>Self-Care (97535)</div>

                    {Object.keys(this.props.activities)
                        .map(key => {
                            const result = this.props.activities[key];
                            return (
                                <AlTemplateSelfCareRow key={result.XLTMPSCNO} id={result.XLTMPSCNO} />
                            )
                        })
                    }
                </div>
            );
        } else {
            return (<span />);
        }
    }
}

function mapStateToProps(state) {
    let noteId = state.ui.patientTabs[state.ui.patientCenter[state.ui.patients.selectedPtno].selectedTab].noteId;

    return {
        activities: state.entities.notes.MLTMPSELFCARE ?
            Object.keys(state.entities.notes.MLTMPSELFCARE)
                .filter(key => {
                    return (state.entities.notes.MLTMPSELFCARE[key].NoteId === noteId)
                })
                .sort((a, b) => state.entities.notes.MLTMPSELFCARE[a].XLTMPSCORDER - state.entities.notes.MLTMPSELFCARE[b].XLTMPSCORDER)
                .map(key => state.entities.notes.MLTMPSELFCARE[key]) : [],
    };
}

const connectedAlTemplateSelfCare = connect(mapStateToProps)(AlTemplateSelfCare);
export { connectedAlTemplateSelfCare as AlTemplateSelfCare };

